var map = {
	"./crm/CRMFeedbackDatatableActions.vue": 59092,
	"./crm/CRMLeadDatatableActions.vue": 76100,
	"./crm/CRMRecordDatatableActions.vue": 34340,
	"./crm/CRMSiteFormDatatableActions.vue": 42572,
	"./crm/CRMTaskDatatableActions.vue": 21840,
	"./egisz/EGISZDatatableActions.vue": 48196,
	"./marketing/MarketingGroupDatatableActions.vue": 83612,
	"./marketing/MarketingMailingDatatableActions.vue": 73452,
	"./marketing/MarketingNotificationAllDatatableActions.vue": 73488,
	"./marketing/MarketingNotificationDatatableActions.vue": 3488,
	"./patients/PatientDatatableActions.vue": 53240,
	"./patients/PatientDatatableAdvanceActions.vue": 12552,
	"./patients/PatientDatatableNotificationActions.vue": 17292,
	"./patients/PatientDatatablePlanTreatmentActions.vue": 20640,
	"./patients/PatientDatatableRecordActions.vue": 31080,
	"./patients/PatientWaitingListDatatableActions.vue": 29560,
	"./patients/PaymentDatatableActions.vue": 2408,
	"./planning/PlanningPatientDatatableActions.vue": 87984,
	"./services/ServicesDatatableActionsArchive.vue": 55256,
	"./services/ServicesDatatableActionsPrice.vue": 6684,
	"./services/ServicesDatatableActionsServiceCategory.vue": 79584,
	"./staff/StaffDatatableAdministratorActions.vue": 98628,
	"./staff/StaffDatatableChairActions.vue": 88278,
	"./staff/StaffDatatableDoctorActions.vue": 32816,
	"./staff/StaffDatatableRecordActions.vue": 60506,
	"./staff/StaffDatatableTechnicActions.vue": 48736,
	"./superadmin/SuperAdminClinicsActions.vue": 97084,
	"./superadmin/SuperAdminPatientsActions.vue": 49404,
	"./superadmin/SuperAdminPaymentActions.vue": 68064,
	"./superadmin/SuperAdminTariffActions.vue": 66788,
	"./superadmin/SuperAdminUsersActions.vue": 47460,
	"./warehouse/WarehouseDatatableActionsMaterialStock.vue": 58996,
	"./warehouse/WarehouseDatatableActionsOperation.vue": 99459,
	"./warehouse/WarehouseDatatableActionsWarehouse.vue": 68364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97080;